module.exports = __webpack_public_path__ + "img/71.95a5f052.jpg";